<template>  
   
        <v-card>
            <v-card-title>
                <h4 class="headline ma-0 grey--text text--darken-2">Profilübersicht</h4>
            </v-card-title>
            <v-list>    
                <v-list-tile>
                    <v-list-tile-content>                                                
                        <span >Name: {{ user.forename }} {{ user.name }}</span>                        
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>                        
                        <span >Letzter Login: {{ user.lastlogin_at }}</span>                        
                    </v-list-tile-content>
                </v-list-tile>
                
                <v-list-tile>
                    <v-list-tile-content>
                                                    
                        <span >Letzte Aktivität:</span>

                    </v-list-tile-content>
                </v-list-tile>
                
            </v-list>
        </v-card>                
    
</template>

<script>



export default {
    
    computed: {
        
        user: function() {
            return this.$store.getters.authUser
        }
        
    }
    
    

    
}
</script>

<style>
    
    
</style>




// WEBPACK FOOTER //
// profilCard.vue?5c91d0db